/* eslint-disable react/prop-types */
import ArgonTypography from "components/ArgonTypography";

const activityAttendanceTableData4 = (leaveEntries = []) => {
  const rows = (Array.isArray(leaveEntries) ? leaveEntries : []).map((entry, index) => {
    const addedOn = entry?.addedOn ? new Date(entry.addedOn) : null;
    const startDate = entry?.startDate
      ? new Date(entry.startDate)
      : entry?.date
      ? new Date(entry.date)
      : null;
    const endDate = entry?.endDate
      ? new Date(entry.endDate)
      : entry?.date
      ? new Date(entry.date)
      : null;
    const addedOnLabel =
      addedOn && !Number.isNaN(addedOn.getTime()) ? addedOn.toLocaleDateString("en-GB") : "NA";
    const startDateLabel =
      startDate && !Number.isNaN(startDate.getTime())
        ? startDate.toLocaleDateString("en-GB")
        : "NA";
    const endDateLabel =
      endDate && !Number.isNaN(endDate.getTime()) ? endDate.toLocaleDateString("en-GB") : "NA";

    return {
      "S.No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "Added on": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {addedOnLabel}
        </ArgonTypography>
      ),
      "Start Date": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {startDateLabel}
        </ArgonTypography>
      ),
      "End Date": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {endDateLabel}
        </ArgonTypography>
      ),
      "Leave By": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {entry?.message || "NA"}
        </ArgonTypography>
      ),
    };
  });

  return {
    columns: activityAttendanceTableData4.columns,
    rows,
  };
};

activityAttendanceTableData4.columns = [
  { name: "S.No.", align: "center" },
  // { name: "Added on", align: "center" },
  { name: "Start Date", align: "center" },
  { name: "End Date", align: "center" },
  { name: "Leave By", align: "center" },
];

activityAttendanceTableData4.rows = [];

export default activityAttendanceTableData4;
